import { Turret } from "./Turret";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { Enemy } from "../enemies/Enemy";
import { MathUtils } from "../utils/MathUtils";
import { Arrow } from "./shots/Arrow";

export class CrossbowTurret extends Turret {

    private canonShoot: string;

    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_PEA, p, engine, skipBuild, level);

        this.canonShoot = "center";

        this.y -= .25;

        this.projectileSpeed = GameConstants.ARROW_SPEED;

        this.calculateTurretParameters();
    }

    // estos valores estan sacados del anuto
    protected calculateTurretParameters(): void {

        this.damage = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_DAMAGE][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_PRICE_UPGRADE][this.level - 1];

        super.calculateTurretParameters();
    }

    protected shoot(): void {

        super.shoot();

        let enemy: Enemy;

        if (this.fixedTarget) {
            enemy = this.followedEnemy || this.enemiesWithinRange[0];
        } else {
            enemy = this.enemiesWithinRange[0];
        }

        let ticksToImpact: number;
        let impactPosition: {x: number, y: number};
        let d = this.range;

        let iterations = 2;
        
        
        for (let i = 0; i < iterations; i ++) {
            ticksToImpact = Math.floor(d / this.projectileSpeed);
            impactPosition = enemy.getNextPosition(ticksToImpact);
            if (impactPosition) {
                impactPosition.y += enemy.deltaYBoundingRadius;
                d = MathUtils.fixNumber(Math.sqrt((this.x - impactPosition.x) * (this.x - impactPosition.x) + (this.y - impactPosition.y) * (this.y - impactPosition.y)));
            }
            
        }

        if (impactPosition) {
            const dx = impactPosition.x - this.x;
            const dy = impactPosition.y - this.y;

            this.shootAngle = MathUtils.fixNumber(Math.atan2(dy, dx));
            const bullet = new Arrow({x: this.x, y: this.y}, this.shootAngle, enemy, this.damage, this.canonShoot, this, this.engine);

            this.engine.addBullet(bullet, this);
        }
    }
}
